<template>
  <div>
    <div class="main_control_panel">
      <div class="data_select_element" v-show="selectElementOb">
        <button @click="closeSelectData" class="close_select_data">X</button>
        <pre>{{ dataSelectElement | pretty }}</pre>
      </div>
      <div class="control_panel" v-show="landsChoseToEdit.length">
        <button class="cancel" @click="cancel">Отмена</button>
        <button
          class="delete"
          @click="deleteChoseArea"
          v-show="landsChoseToEdit.length"
        >
          Удалить выделенные объекты
        </button>
      </div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
        @map-was-initialized="firstMapInit"
      >
        <ymap-marker
          v-for="(element, index) in elements"
          :coords="element.coordinates"
          :marker-type="element.type"
          :hint-content="getElementHintContentHover(element.name)"
          :properties="{ data: element.data, id: element.id, delete: 'N' }"
          :options="overlayEditMapOptions"
          :marker-id="index"
          v-bind:key="index"
          @click="clickPolygon"
          @click.right="clickRightButton"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "mapYandex",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      map: false,
      url: config.backend_url,
      coords: [55.755819, 37.617644],
      coordsCenter: [55.755819, 37.617644],
      elements: [],
      landsChoseToEdit: [],
      selectElementOb: false,
      fillColor: "#307c0d",
      fillColorChosed: "#7c0d16",
      fillColorSelect: "#b9b9b9"
    };
  },
  computed: {
    overlayEditMapOptions: function() {
      return {
        fillColor: this.fillColor,
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      };
    },
    dataSelectElement: function() {
      return this.selectElementOb
        ? this.selectElementOb.properties.get("data")
        : false;
    }
  },
  methods: {
    clickPolygon(e) {
      let element = e.get("target");
      if (this.selectElementOb === element) {
        element.options.set("fillColor", this.fillColor);
        element.properties.set("selected", "N");
        this.selectElementOb = false;
      } else {
        this.selectElementOb = element;
        this.unselectElements();
        element.options.set("fillColor", this.fillColorSelect);
        element.properties.set("selected", "Y");
      }
    },
    closeSelectData() {
      this.selectElementOb.properties.set("selected", "N");
      this.selectElementOb.options.set("fillColor", this.fillColor);
      this.selectElementOb = false;
    },
    unselectElements() {
      let self = this;
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          if (ob.properties.get("selected") === "Y") {
            ob.properties.set("selected", "N");
            ob.options.set("fillColor", self.fillColor);
          }
        });
      });
    },
    clickRightButton(e) {
      let element = e.get("target");
      let id = element.properties.get("id");
      if (this.landsChoseToEdit.includes(id)) {
        this.landsChoseToEdit.splice(this.landsChoseToEdit.indexOf(id), 1);
        element.options.set("fillColor", this.fillColor);
        element.properties.set("delete", "N");
      } else {
        this.landsChoseToEdit.push(id);
        element.options.set("fillColor", this.fillColorChosed);
        element.properties.set("delete", "Y");
      }
    },
    deleteChoseArea() {
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          if (ob.properties.get("delete") === "Y") {
            geoCollection.remove(ob);
          }
        });
      });

      if (this.landsChoseToEdit.length > 0) {
        let data = {
          url: this.url + "cadastr/delete/",
          data: this.landsChoseToEdit,
          method: "POST"
        };
        this.$store
          .dispatch("query/sendRequest", data)
          .then(function(response) {
            console.log(response);
          });
        this.landsChoseToEdit = [];
      }
    },
    cancel() {
      let self = this;
      this.map.geoObjects.each(function(geoCollection) {
        geoCollection.each(function(ob) {
          ob.options.set("fillColor", self.fillColor);
          ob.properties.set("delete", "N");
        });
      });
      this.landsChoseToEdit = [];
    },
    firstMapInit: function(map) {
      this.map = map;
    },
    getElementHintContentHover(name) {
      return (
        "<div style='background-color: #ffffff;position: absolute;left:0;top:-1vh; display: flex;border-radius: 4vh;padding: 1vh .5vh;align-items: center;'>" +
        "<div style='background-color: #FFC5A4; border-radius: 100%; position: absolute;left: 0;top: 0; height: 5vh; width: 5vh;display: flex;align-items: center;'>" +
        "</div>" +
        "<div style='font-size: 2.3vh;line-height: 3vh; margin-left: 7vh; margin-right: 2vh'>" +
        name +
        "</div>" +
        "</div>"
      );
    }
  },
  created() {
    let self = this;
    let data = {
      url: self.url + "cadastr/get/",
      data: {},
      method: "POST"
    };
    this.$store.dispatch("query/sendRequest", data).then(function(response) {
      let data = response.data;
      if (!data.error) {
        let elementsData = [];
        let coordsCenter = self.coordsCenter;

        for (const [key, value] of Object.entries(data)) {
          let coord = JSON.parse(value.COORDINATES);
          let data = JSON.parse(value.DATA);
          let valueCoord = {};
          valueCoord.name = value.CADASTR;
          valueCoord.data = data;
          valueCoord.type = "Polygon";
          valueCoord.id = parseInt(value.ID);
          valueCoord.coordinates = [];
          valueCoord.coordinates.push(coord);
          elementsData.push(valueCoord);
          coordsCenter = coord[0];
        }

        console.log(elementsData);
        self.coordsCenter = coordsCenter;
        self.elements = elementsData;
      }
    });
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    }
  }
};
</script>

<style>
.main_control_panel {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.close_select_data {
  position: absolute;
  right: 30px;
  top: 10px;
}
.data_select_element {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 10px 10px 30px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  color: black;
  height: 100px;
}

.data_select_element.max-height {
  height: 80%;
  overflow: scroll;
}

input.error {
  border-color: red;
}

.data_select_element.access_line {
  height: 480px;
}
.access_line > div {
  float: left;
  margin: 20px;
}
.data_select_element.access_line img {
  background-color: #dbdbdb;
}
.data_select_element pre {
  overflow: auto;
  width: 110%;
  height: 100px;
}
.control_panel {
  position: absolute;
  right: 0;
  top: 0;
  max-width: 150px;
  padding: 15px;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
}
.control_panel button {
  width: 100%;
  border: none;
  border-radius: 4px;
  padding: 5px;
  color: white;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
}
.control_panel button.delete {
  background: red;
}
.control_panel button.cancel {
  background: #46bd87;
}
.ymap-container {
  width: 100vw;
  height: 80vh;
  display: flex;
}
</style>
